import { OrderFilters } from '@interfaces';

export const MAX_CLIENT_IDS = 100;

export function normalizeQueryParamArray(
  value: string | string[] | undefined,
): string[] {
  if (value === undefined || value === '') return [];
  return Array.isArray(value) ? value : [value];
}

export function mergeClientIds(
  ferreteriaIds?: string[],
  aliasIds?: string[],
): string[] {
  return Array.from(new Set([...(ferreteriaIds ?? []), ...(aliasIds ?? [])]));
}

export function countActiveFilters(filters: Partial<OrderFilters>): number {
  const families = [
    Boolean(filters.dateFrom || filters.dateTo),
    Boolean(filters.ferreteriaIds?.length),
    Boolean(filters.aliasIds?.length),
    Boolean(filters.orderNumber),
    Boolean(filters.urgency?.length),
  ];

  return families.filter(Boolean).length;
}

function areSameDates(a?: string, b?: string): boolean {
  return (a ?? '') === (b ?? '');
}

function areSameSelections(a?: string[], b?: string[]): boolean {
  const left = [...(a ?? [])].sort();
  const right = [...(b ?? [])].sort();

  return (
    left.length === right.length &&
    left.every((id, index) => id === right[index])
  );
}

export function areFiltersEqual(
  draft: Partial<OrderFilters>,
  applied: Partial<OrderFilters>,
): boolean {
  return (
    areSameDates(draft.dateFrom, applied.dateFrom) &&
    areSameDates(draft.dateTo, applied.dateTo) &&
    areSameSelections(draft.ferreteriaIds, applied.ferreteriaIds) &&
    areSameSelections(draft.aliasIds, applied.aliasIds) &&
    areSameSelections(draft.urgency, applied.urgency)
  );
}
